import type React from 'react';
import { Box, Text, Link, Icon } from '@nimbus-ds/components';
import { ExternalLinkIcon } from '@nimbus-ds/icons';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';

interface RejectedNuvemPagoPaymentInfoProps {
  gatewayLink?: string | null;
  openGatewayLink: (gatewayLink: string) => void;
  openNuvemPago: () => void;
}

function RejectedNuvemPagoPaymentInfo({
  gatewayLink,
  openGatewayLink,
  openNuvemPago,
}: Readonly<RejectedNuvemPagoPaymentInfoProps>): React.JSX.Element {
  const t = useTranslationOrders('cardPayment');

  return (
    <Box display="flex">
      <Text>
        {t('rejectedNuvemPagoPaymentInfo1')}{' '}
        <Link
          appearance="primary"
          as="button"
          onClick={
            gatewayLink ? () => openGatewayLink(gatewayLink) : openNuvemPago
          }
        >
          {t('rejectedNuvemPagoPaymentInfo2')}
          <Icon color="currentColor" source={<ExternalLinkIcon />} />
        </Link>{' '}
        {t('rejectedNuvemPagoPaymentInfo3')}
      </Text>
    </Box>
  );
}

export default RejectedNuvemPagoPaymentInfo;
